var map = {
	"./archiveItems.js": 9712,
	"./auth.js": 1160,
	"./authfack.js": 6575,
	"./baners.js": 5401,
	"./basketItems.js": 136,
	"./bodymails.js": 364,
	"./complectItems.js": 3770,
	"./complectrItems.js": 3901,
	"./currencies.js": 2035,
	"./deliveredItems.js": 5986,
	"./deliveredrItems.js": 420,
	"./discounts.js": 1149,
	"./layout.js": 2986,
	"./mst.js": 7530,
	"./newItems.js": 8966,
	"./news.js": 3028,
	"./notification.js": 8007,
	"./orders.js": 4457,
	"./pages.js": 1623,
	"./pickupsItems.js": 2240,
	"./pickupsrItems.js": 6674,
	"./returnsItems.js": 1362,
	"./sites.js": 4433,
	"./stuffings.js": 4526,
	"./todo.js": 4995,
	"./users.js": 7610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2115;